<template>
  <v-flex xs6 md3>
    <div @click="$emit('click','Cambio la data por la emision del componente hijo')" class="e-unitCard--link">
      <v-card class="e-cardGramatica e-elevation--4 e-border--radius">
        <v-card-title class="primary text-xs-center pa-3 px-2 justify-space-between">
          <h4 class="e-subTitle white--text">{{ titulo }}</h4>
          <img src="../../assets/images/unit/icongramatica.png" height="35">
        </v-card-title>
        <v-card-text >
          <p class="e-description-big mb-0">{{ descripcion }}</p>
        </v-card-text>
      </v-card>
    </div>
  </v-flex>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    },
    titulo: {
      type: String,
      default: ''
    },
    descripcion: {
      type: String,
      default: ''
    }
  }
}
</script>